export default class Navigation
{
    constructor(element)
    {
        this.element        = element;
        this.closeTimeout   = null;
        this.navTransition  = 400;

        this.initElements();
        this.initEvents();
    }

    initElements()
    {
        this.primary = {
            lastOpenedSub: null,
            hoveringSub: false,
            container: this.element.querySelector('.navigation__primary'),
            subsContainer: this.element.querySelector('.navigation__subs-container'),
            subsBackground: this.element.querySelector('.navigation__subs-background'),
            hover: {
                element: this.element.querySelector('.navigation__primary .navigation__hover'),
                list: this.element.querySelector('.navigation__primary .navigation__hover .navigation__list'),
                timeout: null,
            },
            items: {},
        };

        Array.from(this.element.querySelectorAll('.navigation__primary > .navigation__list .navigation__list-item')).forEach((item, index) => {
            this.primary.items[index] = {
                element: item,
            };

            if(item.dataset.item){
                this.primary.items[index].submenu = this.element.querySelector('.navigation__sub[data-parent="'+item.dataset.item+'"]');
            }
        });

        this.secondary = {
            hover: {
                element: this.element.querySelector('.navigation__secondary .navigation__hover'),
                list: this.element.querySelector('.navigation__secondary .navigation__hover .navigation__list'),
                timeout: null,
            },
            items: {},
        };

        Array.from(Array.from(this.element.querySelectorAll('.navigation__secondary > .navigation__list .navigation__list-item'))).forEach((item, index) => {
            this.secondary.items[index] = {
                element: item,
            };
        });
    }

    initEvents()
    {
        Object.keys(this.primary.items).forEach((index) => {
            this.primary.items[index].element.addEventListener('mousemove', () => {
                this.openHover(this.primary, index);

                if(this.primary.items[index].submenu){
                    this.openMenu(index);
                    this.primary.lastOpenedSub = index;
                }
            });

            this.primary.items[index].element.addEventListener('mouseleave', () => {
                if(this.primary.items[index].submenu){
                    this.closeMenu();
                } else {
                    this.closeHover(this.primary);
                }
            });
        });

        Object.keys(this.secondary.items).forEach((index) => {
            this.secondary.items[index].element.addEventListener('mousemove', () => {
                this.openHover(this.secondary, index);
            });

            this.secondary.items[index].element.addEventListener('mouseleave', () => {
                this.closeHover(this.secondary);
            });
        });

        [this.primary.subsBackground, this.primary.subsContainer].forEach((item) => {
            item.addEventListener('mousemove', () => {
                this.primary.hoveringSub = true;
                clearTimeout(this.closeTimeout);
                if(this.primary.lastOpenedSub){
                    this.openHover(this.primary, this.primary.lastOpenedSub);
                    this.openMenu(this.primary.lastOpenedSub);
                }
            });

            item.addEventListener('mouseleave', () => {
                this.closeMenu();
            });
        })
    }

    openHover(navElement, index)
    {
        let left    = navElement.items[index].element.offsetLeft;
        let width   = navElement.items[index].element.offsetWidth;

        if(index == 0){
            left    += 2;
            width   -= 2;

            navElement.hover.element.classList.add('navigation__hover--at-first');
        } else {
            navElement.hover.element.classList.remove('navigation__hover--at-first');
        }

        if(index == Object.keys(navElement.items).length - 1){
            navElement.hover.element.classList.add('navigation__hover--at-last');
        } else {
            navElement.hover.element.classList.remove('navigation__hover--at-last');
        }

        navElement.hover.element.style.left = left + 'px';
        navElement.hover.list.style.left = '-' + left + 'px';
        navElement.hover.element.style.width = width + 'px';
        navElement.hover.element.classList.add('navigation__hover--active');
        clearTimeout(navElement.hover.timeout);
        setTimeout(() => {
            navElement.hover.element.classList.add('navigation__hover--ready');
        }, 1);
    }

    closeHover(navElement)
    {
        navElement.hover.element.classList.remove('navigation__hover--active');
        navElement.hover.timeout = setTimeout(() => {
            navElement.hover.element.classList.remove('navigation__hover--ready');
        }, this.navTransition);
    }

    openMenu(index)
    {
        clearTimeout(this.closeTimeout);
        this.openHover(this.primary, index);
        this.setPositioning(this.calculatePositioning(this.primary.items[index].submenu));
        this.closeSubmenus(index);
        this.primary.openedIndex = index;
        this.primary.items[index].submenu.classList.add('navigation__sub--opened');
        setTimeout(() => {
            this.element.classList.add('navigation--sub-opened');
        }, 1);
    }

    closeMenu()
    {
        this.closeHover(this.primary);
        this.closeTimeout = setTimeout(() => {
            this.primary.hoveringSub = false;
            this.setPositioning(this.calculatePositioning());
            this.closeSubmenus();
            this.element.classList.remove('navigation--sub-opened');
        }, 100);
    }

    closeSubmenus(except = null)
    {
        Object.keys(this.primary.items).forEach((index) => {
            if(except !== index && this.primary.items[index].submenu){
                this.primary.items[index].submenu.classList.remove('navigation__sub--opened');
            }
        });
    }

    calculatePositioning(openSubmenu)
    {
        let top     = 0;
        let right   = 0;
        let bottom  = 0;
        let left    = 0;

        if(openSubmenu){
            const properties = {
                container: {
                    boundingClientRect: this.primary.container.getBoundingClientRect(),
                    width: this.primary.container.offsetWidth,
                    height: this.primary.container.offsetHeight,
                },
                openSubmenu: {
                    boundingClientRect: openSubmenu.getBoundingClientRect(),
                    width: openSubmenu.offsetWidth,
                    height: openSubmenu.offsetHeight,
                },
            };

            properties.padding = properties.openSubmenu.boundingClientRect.top - properties.container.boundingClientRect.top - properties.container.height;

            top -= properties.container.boundingClientRect.top;
            right -= window.innerWidth - properties.container.boundingClientRect.left - properties.container.width;
            bottom -= properties.openSubmenu.height + (properties.padding * 2);
            left -= properties.openSubmenu.width - properties.container.width + properties.padding;
        }

        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left,
        }
    }

    setPositioning(positioning)
    {
        this.primary.subsContainer.style.bottom = (positioning.bottom < 0 ? positioning.bottom : 1) + 'px';
        this.primary.subsContainer.style.left = (positioning.left < 0 ? positioning.left : 1) + 'px';

        this.primary.subsBackground.style.top = (positioning.top < 0 ? positioning.top : 1) + 'px';
        this.primary.subsBackground.style.right = (positioning.right < 0 ? positioning.right : 1) + 'px';
        this.primary.subsBackground.style.bottom = (positioning.bottom < 0 ? positioning.bottom : 1) + 'px';
        this.primary.subsBackground.style.left = (positioning.left < 0 ? positioning.left : 1) + 'px';
    }
}
